// Module
var code = `<div class="customize-sheet-item" ng-style="{
  height: \$ctrl.height + 'px',
  'grid-template': \$ctrl.template.gridTemplate
}"> <div ng-repeat="photo in \$ctrl.template.photos" ng-style="{
      'grid-area': photo.gridArea,
      'transform': 'rotate(' +  photo.rotation + 'deg)'
    }" class="photo-container" data-orientation="{{\$ctrl.getOrientation()}}"> <img lt-look-loader="{bearerTokenURL: \$ctrl.bearerTokenUrl, previewImageLocationF: \$ctrl.look.previewImageLocationF, previewImageLocationM: \$ctrl.look.previewImageLocationM, orientation: \$ctrl.look.orientation, layoutThemeID: \$ctrl.look.layoutThemeID, background: \$ctrl.look.background}" alt="Photo preview" class="image-loader-loading-portrait-reset photo-image should-stay-blocked" ng-style="{
        width: photo.width * \$ctrl.CELL_SCALE + 'px',
        height: photo.height * \$ctrl.CELL_SCALE + 'px'
      }"/> </div> </div> `;
// Exports
export default code;